var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CardRoundCtrl',_vm._b({attrs:{"data-test":"close-cross-ctl-general","icon-name":"close-cross","is-active":_vm.isActive ? _vm.isClicked : false},nativeOn:{"click":function($event){_vm.isClicked = true}}},'CardRoundCtrl',{
    iconColor: _vm.iconColor,
    iconSize: _vm.iconSize,
    shapeColor: _vm.shapeColor,
    shapeSize: _vm.shapeSize,
  },false))
}
var staticRenderFns = []

export { render, staticRenderFns }